import { useState } from "react";
import PageContext from "./page-context";
import PropTypes from "prop-types";

const PageProvider = ({ children }) => {
  const [data, setData] = useState({
    title: "",
    headerShow: true,
  });

  return (
    <PageContext.Provider value={{ data, setData }}>
      {children}
    </PageContext.Provider>
  );
};

PageProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PageProvider;
